import { Switch } from "@mui/material";
import { styled } from "@mui/material/styles";
import checkedIcon from "../../assets/icons/toggleCheckedIcon.svg";
import disabledIcon from "../../assets/icons/toggleUncheckedIcon.svg";

const CustomSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))({
  width: "32px",
  height: "21px",
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(12px)",
      color: "#1492AF",
      "& .MuiSwitch-thumb": {
        backgroundImage: `url("${checkedIcon}")`,
        color: "#1492AF",
      },
      "& + .MuiSwitch-track": {
        backgroundColor: "#D4EDF3",
        border: "1px solid #1492AF",
        opacity: 1,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
        backgroundColor: "#E7E9EF",
        border: "1px solid #8792AB",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: "16px",
    height: "16px",
    color: "#8792AB",
    backgroundImage: `url("${disabledIcon}")`,
  },
  "& .MuiSwitch-track": {
    borderRadius: "15px",
    height: "19px",
    backgroundColor: "#E7E9EF",
    opacity: 1,
    border: "1px solid #8792AB",
  },
});

export default CustomSwitch;
